<template>
  <div style="width: 100%;">
    <el-date-picker @change="getShipmentScheduleData" v-model="fromData.day" format="YYYY 年 M 月" value-format="YYYY-M-1" type="month"
                    placeholder="选择月份" :clearable="false"/>
    <div class="divSize" v-loading="shipmentScheduleLoading" element-loading-text="数据加载中"
         style="width: 100%;min-height: 300px;" id="shipmentSchedule"/>
    <el-table :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center', width: '100%',}"  :data="tableData" border style="width: 100%;height:78%;margin-top: 10px">
      <el-table-column v-for="item in tableNameList" :key="item" :prop="item" :label="item" min-width="120"/>
    </el-table>
  </div>

</template>

<script>
import * as echarts from "echarts";

export default {
  name: "MfgShipmentScheduleArea",
  data() {
    return {
      fromData: {
        day:this.getDateFormat(),
      },
      tableData:[],
      tableNameList:[],
      shipmentSchedulePlanTableList:[],
      shipmentScheduleTableList:[],
      differenceTableList:[],
      rateTableList:[],
      //出货进度
      shipmentSchedule: {
        title: [
          {
            text: this.$t('makeSchedule.shipmentSchedulePage.shipProgress'),
            left: '50%',
            textAlign: 'center'
          },],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {bottom: '0',},
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: '{value}'
            }
          },
        ],
        series: [
          {
            barWidth: '50px',
            name: this.$t('makeSchedule.shipmentSchedulePage.shipTarget'),
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value + '(㎡)';
              }
            },
            data: []
          },
          {
            barWidth: '50px',
            name: this.$t('makeSchedule.shipmentSchedulePage.achievements'),
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value + '(㎡)';
              }
            },
            data: []
          },
        ]
      },
      shipmentScheduleLoading: false,
    }
  },methods: {
    getDateFormat() {
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString() + "-1"
    },
    renderEcharts(id, option) {
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)
      }
    },
    async getShipmentScheduleData() {
      if (!this.fromData.day) {
        this.fromData.day = this.getDateFormat()
      }
      this.shipmentScheduleLoading = true
      let {data: res} = await this.$axios.post('mfg/shipmentSchedule/getShipmentScheduleAreaData', this.fromData);
      this.shipmentScheduleLoading = false
      if (res.code !== 0) {
        return this.$message.error(res.message)
      }

      this.tableNameList = res.data.tableNameList
      this.tableData = res.data.tableData
      this.shipmentSchedule.xAxis[0].data = res.data.xAxis
      this.shipmentSchedule.series[0].data = res.data.shipmentSchedulePlanList
      this.shipmentSchedule.series[1].data = res.data.shipmentScheduleList
      let a = this.$common.getDivisor(Math.max(...res.data.shipmentScheduleList))
      let b = this.$common.getDivisor(Math.max(...res.data.shipmentSchedulePlanList))
      let c = 0;let d = 0;
      for (let item of res.data.shipmentScheduleList) {
            if (c < item) {
              c = item;
            }
      }
      for (let item of res.data.shipmentSchedulePlanList) {
        if (d < item) {
          d = item;
        }
      }
      if (c > d) {
        c = res.data.shipmentScheduleList;
        d = a
      } else {
        c = res.data.shipmentSchedulePlanList;
        d = b
      }
      this.shipmentSchedule.yAxis[0].max = Math.ceil(Math.max(...c) / d) * d
      this.shipmentSchedule.yAxis[0].interval = Math.round(this.shipmentSchedule.yAxis[0].max / 5 * 100) / 100
      this.renderEcharts('shipmentSchedule', this.shipmentSchedule)
    }
  },created() {
    this.getShipmentScheduleData();
  }
}
</script>

<style scoped>
.divSize {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>